var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hb-empty" },
    [
      _c("feather-icon", {
        staticClass: "hb-empty__icon",
        attrs: { icon: _vm.icon, size: "28" },
      }),
      _c("p", { staticClass: "hb-empty__title" }, [_vm._v(_vm._s(_vm.title))]),
      _vm.$slots.default
        ? _c("div", { staticClass: "hb-empty__action" }, [_vm._t("default")], 2)
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }